<div class="add-programare-dialog">
    <div class="dialog-header">
        <h2 class="dialog-title">
            <i class="fa-solid fa-calendar-plus me-2"></i>
            Adăugare Programare
        </h2>
        <button type="button" class="btn-close-dialog" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="dialog-content">
        <form [formGroup]="form">
            <!-- Configurație Programare -->
            <div class="section-card">
                <div class="section-header">
                    <i class="fa-solid fa-cog me-2"></i>
                    Configurație Programare
                </div>
                <div class="section-body">
                    <div class="row">
                        <!-- Modul -->
                        <div class="col-md-4 mb-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Modul / Direcție</mat-label>
                                <mat-select formControlName="id_modul" (selectionChange)="onModulChange($event.value)">
                                    <mat-option *ngFor="let item of module" [value]="item.id">
                                        {{ item.name }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="form.get('id_modul')?.hasError('required')">
                                    Câmp obligatoriu
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Locație -->
                        <div class="col-md-4 mb-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Locație</mat-label>
                                <mat-select formControlName="id_locatie"
                                    (selectionChange)="onLocatieChange($event.value)" [disabled]="locatii.length === 0">
                                    <mat-option *ngFor="let item of locatii" [value]="item.id">
                                        {{ item.name }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="form.get('id_locatie')?.hasError('required')">
                                    Câmp obligatoriu
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Serviciu -->
                        <div class="col-md-4 mb-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Serviciu</mat-label>
                                <mat-select formControlName="id_serviciu"
                                    (selectionChange)="onServiciuChange($event.value)"
                                    [disabled]="servicii.length === 0">
                                    <mat-option *ngFor="let item of servicii" [value]="item.id">
                                        {{ item.web_name || item.name }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="form.get('id_serviciu')?.hasError('required')">
                                    Câmp obligatoriu
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <!-- Tip Problemă -->
                        <div class="col-md-6 mb-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Tip Problemă</mat-label>
                                <mat-select formControlName="id_problem_type" [disabled]="tipuriProblema.length === 0">
                                    <mat-option *ngFor="let item of tipuriProblema" [value]="item.id">
                                        {{ item.name }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="form.get('id_problem_type')?.hasError('required')">
                                    Câmp obligatoriu
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Tip Program -->
                        <div class="col-md-6 mb-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Tip Program</mat-label>
                                <mat-select formControlName="id_program_type"
                                    (selectionChange)="onTipProgramChange($event.value)"
                                    [disabled]="tipuriProgram.length === 0">
                                    <mat-option *ngFor="let item of tipuriProgram" [value]="item.id">
                                        {{ item.name }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="form.get('id_program_type')?.hasError('required')">
                                    Câmp obligatoriu
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Data și Ora -->
            <div class="section-card" *ngIf="form.value.id_program_type">
                <div class="section-header">
                    <i class="fa-solid fa-clock me-2"></i>
                    Data și Ora
                </div>
                <div class="section-body">
                    <div class="row">
                        <!-- Calendar -->
                        <div class="col-md-6 mb-3">
                            <div class="calendar-wrapper">
                                <mat-calendar #calendar [selected]="selectedDate" [minDate]="minDate"
                                    [maxDate]="maxDate" [dateFilter]="dateFilter"
                                    (selectedChange)="onDateSelected($event)">
                                </mat-calendar>
                            </div>
                            <mat-error *ngIf="form.get('date')?.touched && form.get('date')?.hasError('required')"
                                class="mt-2">
                                Selectați o dată
                            </mat-error>
                        </div>

                        <!-- Available Slots -->
                        <div class="col-md-6 mb-3">
                            <div class="slots-container" *ngIf="selectedDate">
                                <h5 class="slots-title">
                                    <i class="fa-solid fa-list me-2"></i>
                                    Sloturi disponibile pentru {{ selectedDate | date:'dd.MM.yyyy' }}
                                </h5>

                                <!-- Multi-slot counter -->
                                <div class="slots-counter" *ngIf="maxSloturi > 1 && availableSlots.length > 0">
                                    <span>Puteți selecta până la {{ maxSloturi }} sloturi.</span>
                                    <strong>Selectate: {{ selectedSlots.length }}/{{ maxSloturi }}</strong>
                                </div>

                                <div *ngIf="availableSlots.length === 0 && !isLoading" class="no-slots">
                                    <i class="fa-solid fa-calendar-xmark"></i>
                                    <p>Nu există sloturi disponibile pentru data selectată.</p>
                                </div>

                                <div class="slots-grid" *ngIf="availableSlots.length > 0">
                                    <button type="button" *ngFor="let slot of availableSlots" class="slot-btn"
                                        [class.selected]="maxSloturi > 1 ? isSlotSelected(slot) : form.value.time === slot.time"
                                        [class.disabled]="maxSloturi > 1 && !isSlotSelected(slot) && selectedSlots.length >= maxSloturi"
                                        (click)="onSlotSelected(slot)">
                                        <span class="slot-time">{{ slot.label }}</span>
                                    </button>
                                </div>
                            </div>

                            <div *ngIf="!selectedDate" class="select-date-prompt">
                                <i class="fa-solid fa-hand-pointer"></i>
                                <p>Selectați o dată din calendar pentru a vedea sloturile disponibile.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Date Cetățean -->
            <div class="section-card" *ngIf="form.value.time">
                <div class="section-header">
                    <i class="fa-solid fa-user me-2"></i>
                    Date Cetățean
                </div>
                <div class="section-body">
                    <div class="row">
                        <!-- Nume complet -->
                        <div class="col-md-6 mb-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Nume complet</mat-label>
                                <input matInput formControlName="name" placeholder="Ex: Ion Popescu">
                                <mat-error *ngIf="form.get('name')?.hasError('required')">
                                    Câmp obligatoriu
                                </mat-error>
                                <mat-error *ngIf="form.get('name')?.hasError('minlength')">
                                    Minim 2 caractere
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- CNP -->
                        <div class="col-md-6 mb-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>CNP (opțional)</mat-label>
                                <input matInput formControlName="cnp" placeholder="13 cifre" maxlength="13">
                                <mat-error *ngIf="form.get('cnp')?.hasError('pattern')">
                                    CNP invalid (13 cifre)
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <!-- Telefon -->
                        <div class="col-md-6 mb-3">
                            <div class="phone-input-group">
                                <mat-form-field appearance="outline" class="country-code-field">
                                    <mat-select [(value)]="selectedCountryCode"
                                        (selectionChange)="onCountryCodeChange($event.value)">
                                        <mat-option *ngFor="let cc of countryCodes" [value]="cc">
                                            {{ cc.flag }} {{ cc.dial_code }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="phone-field">
                                    <mat-label>Telefon</mat-label>
                                    <input matInput formControlName="phone" placeholder="712345678">
                                    <mat-error *ngIf="form.get('phone')?.hasError('required')">
                                        Câmp obligatoriu
                                    </mat-error>
                                    <mat-error *ngIf="form.get('phone')?.hasError('pattern')">
                                        Număr invalid
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- Email -->
                        <div class="col-md-6 mb-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Email (opțional)</mat-label>
                                <input matInput formControlName="email" placeholder="email@example.com">
                                <mat-error *ngIf="form.get('email')?.hasError('email')">
                                    Email invalid
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <!-- Observații -->
                        <div class="col-12 mb-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Observații</mat-label>
                                <textarea matInput formControlName="observatii" rows="3"
                                    placeholder="Detalii adiționale despre programare (max 250 caractere)"
                                    maxlength="250"></textarea>
                                <mat-hint align="end">{{ form.value.observatii?.length || 0 }}/250</mat-hint>
                                <mat-error *ngIf="form.get('observatii')?.hasError('required')">
                                    Câmp obligatoriu
                                </mat-error>
                                <mat-error *ngIf="form.get('observatii')?.hasError('maxlength')">
                                    Maximum 250 caractere
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Notificări -->
            <div class="section-card" *ngIf="form.value.time">
                <div class="section-header">
                    <i class="fa-solid fa-bell me-2"></i>
                    Notificări
                </div>
                <div class="section-body">
                    <div class="row">
                        <div class="col-md-6">
                            <mat-checkbox formControlName="send_sms" color="primary">
                                <i class="fa-solid fa-comment-sms me-2"></i>
                                Trimite SMS
                            </mat-checkbox>
                        </div>
                        <div class="col-md-6">
                            <mat-checkbox formControlName="send_email" color="primary">
                                <i class="fa-solid fa-envelope me-2"></i>
                                Trimite Email
                            </mat-checkbox>
                            <span class="hint-text" *ngIf="!form.value.email && form.value.send_email">
                                (necesită adresă de email)
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="dialog-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="resetForm()">
            <i class="fa-solid fa-rotate-left me-2"></i>
            Reset
        </button>

        <div class="footer-actions">
            <button type="button" class="btn btn-outline-primary" (click)="closeDialog()">
                Anulează
            </button>
            <button type="button" class="btn btn-primary" (click)="submitForm(false)"
                [disabled]="isSaving || form.invalid || !form.value.time">
                <i class="fa-solid fa-floppy-disk me-2" *ngIf="!isSaving"></i>
                <i class="fa-solid fa-spinner fa-spin me-2" *ngIf="isSaving"></i>
                Salvează
            </button>
            <button type="button" class="btn btn-success" (click)="submitForm(true)"
                [disabled]="isSaving || form.invalid || !form.value.time">
                <i class="fa-solid fa-check me-2" *ngIf="!isSaving"></i>
                <i class="fa-solid fa-spinner fa-spin me-2" *ngIf="isSaving"></i>
                Salvează și Închide
            </button>
        </div>
    </div>
</div>

<!-- Loading Overlay -->
<div class="loading-overlay" *ngIf="isLoading">
    <div class="spinner-container">
        <mat-spinner diameter="50"></mat-spinner>
        <p>Se încarcă...</p>
    </div>
</div>